import { GoogleMap } from '@react-google-maps/api'
import React, { useMemo } from 'react'
import { ContactSalesRepresentativesFilters } from '../../pages/contactSalesRepresentatives'
import { useCurrentLocale } from '../../src/contexts/CurrentLanguageContext'
import { VendorFragment } from '../../src/model/fragments'
import { VendorInfoWindow } from './VendorInfoWindow'
import { VendorMarkers } from './VendorMarkers'
import { getMapCenter, getMapOptions, makeMapMarker } from '../../src/utils/map'

export interface VendorsMapProps {
	contactPlaces: VendorFragment[]
	selectedPlace: null | string
	setSelectedPlace: (i: null | string) => void
	filter: ContactSalesRepresentativesFilters
}

export const VendorsMap: React.FunctionComponent<VendorsMapProps> =
	({ contactPlaces, selectedPlace, setSelectedPlace, filter }) => {
		const locale = useCurrentLocale()
		const mapCenter = useMemo(() => getMapCenter(locale), [locale])
		const onClosePlace = React.useCallback(
			() => setSelectedPlace(null),
			[setSelectedPlace],
		)
		const selectedPlaceObj = useMemo(
			() =>
				!selectedPlace
					? undefined
					: contactPlaces.find((it) => it.id === selectedPlace),
			[contactPlaces, selectedPlace],
		)
		const mapRef = React.useRef<GoogleMap | null>(null)

		const [marker, setMarker] = React.useState<google.maps.Marker | null>(null);
		const [lastAddress, setLastAddress] = React.useState<google.maps.LatLngLiteral | null>(null);
		React.useEffect(() => {
			if (!mapRef.current) {
				return
			}

			if(marker)
			{
				marker.setMap(null);
			}

			if(filter.address)
			{
				mapRef.current.state.map?.setCenter(filter.address)
				mapRef.current.state.map?.setZoom(11)


				setMarker(new google.maps.Marker({
					position: filter.address,
					map: mapRef.current.state.map,
					icon: makeMapMarker()
				}));
			}
			else if(lastAddress != null)
			{
				mapRef.current.state.map?.setCenter(mapCenter)
				mapRef.current.state.map?.setZoom(8)
			}

			setLastAddress(filter.address);

		}, [filter]);

		React.useEffect(() => {
			if (selectedPlaceObj && mapRef.current) {
				mapRef.current.state.map?.panTo({
					lat: Number(selectedPlaceObj.gpsLat),
					lng: Number(selectedPlaceObj.gpsLng),
				})
			}
		}, [selectedPlaceObj])

		const initZoom = React.useMemo(() => {
			if(globalThis.window && globalThis.window.innerWidth < 600)
			{
				return 7;
			}

			return 8;
		}, []);

		return (
			<GoogleMap
				ref={mapRef}
				mapContainerClassName="salesRespresentativesMap-map-in"
				zoom={initZoom}
				options={getMapOptions()}
				center={mapCenter}
			>
				<VendorMarkers
					places={contactPlaces}
					selectedPlace={selectedPlace}
					setSelectedPlace={setSelectedPlace}
				/>
				<VendorInfoWindow
					onClose={onClosePlace}
					place={selectedPlaceObj}
				/>
			</GoogleMap>
		)
	}

